import { i18n } from 'i18next';

const toggleLanguage = (i18n: i18n) => {
  const newLanguage = i18n.language.startsWith('en') ? 'fi' : 'en';
  i18n.changeLanguage(newLanguage);
};

export default toggleLanguage;
